var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutopay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "repeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snoo_rental",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_acc_overview_order_delivered_rename",
    transform: "translate(-980.000000, -493.000000)",
    stroke: "#4D596B",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(191.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(790.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeat",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "6.22222222 0 8 1.84812834 6.22222222 3.69625668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.62032086 L0,3.69625668 C-1.97372982e-16,2.67556359 0.795938223,1.84812834 1.77777778,1.84812834 L8,1.84812834",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "1.77777778 10.1647059 0 8.31657754 1.77777778 6.4684492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,5.54438503 L8,6.4684492 C8,7.4891423 7.20406178,8.31657754 6.22222222,8.31657754 L0,8.31657754",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopay);
export default __webpack_public_path__ + "static/media/autopay.8917c4155ae5785820dfaed9a91e6c58.svg";
export { ForwardRef as ReactComponent };